module.exports = __webpack_public_path__ + "img/gzh.cc71abbf.png";